"use strict";

(function () {
  const TOAST_ID = "hatton-mobile-cart-toast";
  let hideTimer = null;
  let pendingResetTimer = null;

  const isMobileViewport = () => window.matchMedia("(max-width: 767px)").matches;

  const ensureToast = () => {
    let toast = document.getElementById(TOAST_ID);
    if (toast) {
      return toast;
    }

    toast = document.createElement("div");
    toast.id = TOAST_ID;
    toast.className = "c-mobile-cart-toast";
    toast.innerHTML = [
      '<div class="c-mobile-cart-toast__title"></div>',
      '<div class="c-mobile-cart-toast__meta"></div>',
      '<div class="c-mobile-cart-toast__actions">',
      '<button type="button" class="c-mobile-cart-toast__link">View Bag</button>',
      '<a class="c-mobile-cart-toast__checkout" href="#">Checkout</a>',
      "</div>",
    ].join("");
    document.body.appendChild(toast);
    return toast;
  };

  const showToast = (payload) => {
    if (!isMobileViewport() || !payload) {
      return;
    }

    const toast = ensureToast();
    const title = toast.querySelector(".c-mobile-cart-toast__title");
    const meta = toast.querySelector(".c-mobile-cart-toast__meta");
    const viewBag = toast.querySelector(".c-mobile-cart-toast__link");
    const checkout = toast.querySelector(".c-mobile-cart-toast__checkout");

    if (!title || !meta || !viewBag || !checkout) {
      return;
    }

    title.textContent = payload.title || "Added to bag";

    const metaParts = ["Added to your bag"];
    if (payload.variant) {
      metaParts.push(payload.variant);
    }
    if (payload.price) {
      metaParts.push(payload.price);
    }
    meta.textContent = metaParts.join(" • ");

    checkout.href = payload.checkoutUrl || `${window.Shopify.routes.root}checkout`;

    toast.classList.add("is-active");

    clearTimeout(hideTimer);
    hideTimer = window.setTimeout(() => {
      toast.classList.remove("is-active");
    }, 5000);
  };

  const clearPendingMobileAdd = () => {
    window.HattonPendingMobileCartToast = null;
    document.body.classList.remove("hatton-mobile-cart-toast-pending");
    clearTimeout(pendingResetTimer);
  };

  const closeSideCartIfOpen = () => {
    document.body.classList.remove("side-cart-active");
    const sideCart = document.querySelector(".s-side-cart");
    const overlay = document.querySelector(".js-side-cart__overlay");
    const content = document.querySelector(".js-side-cart__content");

    if (sideCart) {
      sideCart.classList.remove("s-side-cart--open");
    }

    if (overlay) {
      overlay.classList.remove("is-active");
    }

    if (content) {
      content.classList.remove("is-active");
    }
  };

  const handleCartUpdated = () => {
    const payload = window.HattonPendingMobileCartToast;
    const isFreshPendingAdd = payload && Date.now() - payload.timestamp < 5000;

    if (!isMobileViewport() || !isFreshPendingAdd) {
      clearPendingMobileAdd();
      return;
    }

    closeSideCartIfOpen();
    showToast(payload);
    clearPendingMobileAdd();
  };

  const registerPendingMobileAdd = (event) => {
    if (!isMobileViewport()) {
      return;
    }

    const submitButton = event.target.closest(".js-product-main__form-submit");
    if (!submitButton) {
      return;
    }

    const root = submitButton.closest("c-product-main");
    if (!root) {
      return;
    }

    const variantPicker = root.querySelector(".js-product-main__option");
    if (variantPicker && !variantPicker.querySelector("input:checked")) {
      return;
    }

    const checkedInput = root.querySelector(".js-product-main__option-input:checked");
    const selectedLabel = checkedInput
      ? checkedInput.closest(".c-product-main__option-label")
      : null;
    const title = root.querySelector(".c-product-main__title");
    const price = root.querySelector(".c-product-main__price");

    window.HattonPendingMobileCartToast = {
      title: title ? title.textContent.trim() : "Added to bag",
      variant: selectedLabel ? selectedLabel.textContent.trim() : "",
      price: price ? price.textContent.trim() : "",
      cartUrl: `${window.Shopify.routes.root}cart`,
      checkoutUrl: `${window.Shopify.routes.root}checkout`,
      timestamp: Date.now(),
    };
    document.body.classList.add("hatton-mobile-cart-toast-pending");
    clearTimeout(pendingResetTimer);
    pendingResetTimer = window.setTimeout(clearPendingMobileAdd, 5000);
  };

  const handleToastClick = (event) => {
    const viewBagButton = event.target.closest(".c-mobile-cart-toast__link");
    if (!viewBagButton) {
      return;
    }

    event.preventDefault();
    const toast = document.getElementById(TOAST_ID);
    if (toast) {
      toast.classList.remove("is-active");
    }

    if (window.PubSub && typeof window.PubSub.publish === "function") {
      window.PubSub.publish("toggle-side-cart");
    }
  };

  const initializeMobileCartToast = () => {
    document.addEventListener("click", registerPendingMobileAdd, true);
    document.addEventListener("click", handleToastClick);

    if (window.PubSub && typeof window.PubSub.subscribe === "function") {
      window.PubSub.subscribe("open-mobile-cart-toast", showToast);
      window.PubSub.subscribe("cart-updated", handleCartUpdated);
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeMobileCartToast, { once: true });
  } else {
    initializeMobileCartToast();
  }
})();
